<script setup>
definePageMeta({
  name: "hjem",
  layout: "default",
})

useHead({
  bodyAttrs: {
    class: "bg-[--theme-lightest]",
  },
})
</script>

<template>
  <div
    class="mb-14 flex w-full flex-col items-center justify-center gap-14"
  >
    <UPlatformDescription />
    <UProductList />
  </div>
</template>
